<script setup lang="ts">
import { computed, watch } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';
import DelivererHeader from './components/layout/DelivererHeader.vue';
import BottomNav from './components/layout/BottomNav.vue';
import { useDelivererAuthStore } from './stores/auth';
import { useDelivererStore } from './stores/deliverer';
import { useOrdersStore } from './stores/orders';
import { initPushNotifications } from './composables/usePushNotifications';
import MobileGate from '../shared/components/MobileGate.vue';
import EnvRibbon from '../../shared/EnvRibbon.vue';
import VersionBadge from '../../shared/VersionBadge.vue';

const auth = useDelivererAuthStore();
const deliverer = useDelivererStore();
const ordersStore = useOrdersStore();
const route = useRoute();
const router = useRouter();

const AUTH_PATHS = ['/login', '/activate', '/forgot-password', '/reset-password', '/conta/dados-pessoais', '/conta/veiculo'];

const showLayout = computed(() =>
    auth.isAuthenticated && !AUTH_PATHS.some(p => route.path.startsWith(p))
);

watch(() => auth.isAuthenticated, (authenticated) => {
    if (authenticated) {
        deliverer.fetchProfile();
        initPushNotifications();
    } else {
        router.push('/login');
    }
}, { immediate: true });

// Reassina o canal do entregador em qualquer boot (login fresco ou reload de página).
// O watch em delivererId garante que o token já está no localStorage antes de montar o Echo.
watch(() => auth.delivererId, (id) => {
    if (id) ordersStore.subscribeToDelivererChannel(id);
}, { immediate: true });
</script>

<template>
    <EnvRibbon />
    <MobileGate>
        <div class="flex flex-col min-h-screen" style="background: #F7F8FA;">
            <DelivererHeader v-if="showLayout" />
            <main
                class="flex-1 overflow-y-auto"
                :class="showLayout ? 'pb-[calc(4.5rem+env(safe-area-inset-bottom,0px))]' : ''"
            >
                <RouterView />
            </main>
            <BottomNav v-if="showLayout" />
            <div class="fixed bottom-1 right-2 z-40 pointer-events-none">
                <VersionBadge />
            </div>
        </div>
    </MobileGate>
</template>
